// import { Component } from '@angular/core';
// import { ActivatedRoute, Router } from '@angular/router';
// import { Opdata } from 'src/app/models/opdata.model';
// import { OpdataCalc } from 'src/app/models/opdataCalc.model';
// import { Stage } from 'src/app/models/stage.interface';
// import { Train } from 'src/app/models/train.model';
// import { OpdataService } from 'src/app/services/opdata/opdata.service';
// import { TrainService } from 'src/app/services/trains/trains.service';
// import { PlotlyService } from '../plotly.service';
// import { param } from 'jquery';
// import { PlantsService } from 'src/app/services/plants/plants.service';
// import { Plant } from 'src/app/models/plant.model';
// import { EventLogs } from 'src/app/models/eventLog.model';
// import { EventlogsService } from 'src/app/services/eventlogs/eventlogs.service';
// import { RawCalcTrainDataViewModel } from 'src/app/models/OpRawCalc.model';

// @Component({
//   selector: 'app-primarygraph',
//   templateUrl: './primarygraph.component.html',
//   styleUrls: ['./primarygraph.component.scss']
// })
// export class PrimarygraphComponent {
//   opCalData: RawCalcTrainDataViewModel[] = []
//   plantName: string = ""
//   trainDetails: Train = new Train();
//   trainInfo: Train = new Train();
//   trainId: string = ""
//   plantId: string = ""
//   graphName: string = ""
//   graphName2: string = ""
//   graphName3: string = ""
//   yaxisname1: string = ""
//   yaxisname2: string = ""
//   yaxisname3: string = ""
//   showselector: boolean = false;
//   stageEnabled: boolean = true;
//   stageselected: string = "1";
//   stagestr: number;
//   stagenumber: string = "";
//    maxYaxisNpf: number;
//    maxYaxisNsp :number;
//    maxYaxisNdf: number;

//    maxtotalNPF:number;
//    maxstage1NPF:number;
//    maxstage2NPF:number;
//    maxstage3NPF:number;
//     ymax : number;
//    maxtotalNsp:number;
//    maxstage1Nsp:number;
//    maxstage2Nsp:number;
//    maxstage3Nsp:number;

//    maxtotalNdf:number;
//    maxstage1Ndf:number;
//    maxstage2Ndf:number;
//    maxstage3Ndf:number;
//   public stage3: Array<Stage> = [
//     { Id: 1, Name: 'Total' },
//     { Id: 2, Name: '1' },
//     { Id: 3, Name: '2' },
//     { Id: 4, Name: '3' },
//   ];
//   public stage2: Array<Stage> = [
//     { Id: 1, Name: 'Total' },
//     { Id: 2, Name: '1' },
//     { Id: 3, Name: '2' },

//   ];

//   public stageTotal: Array<Stage> = [
//     { Id: 1, Name: 'Total' },
//   ];

//   plants: Plant[] = [];
//   trains: Train[] = [];
//   plantDetails: Plant = new Plant();
//   Eventlogs: EventLogs[] = [];
//   loggedInUserRole: string;
//   loggedinUserId: string;
//   plantAndUserId: string;

//  /*  constructor(
//     private plot: PlotlyService,
//     private trainService: TrainService,
//     private plantService: PlantsService,
//     private route: ActivatedRoute,
//     private opdataService: OpdataService,
//     private EventlogsService: EventlogsService
//   ) 
//   {
//     this.route.queryParams.subscribe(params => {
//       if(params['trainId']!=null)
//       {
//       this.showselector = params["showselector"];
//       this.trainId = atob(params['trainId']!);
//       this.plantId = params['plantId'];
      
//       this.plantName = atob( params["plantName"]);
//       if (this.plantId) {
//         this.plantId = atob(params['plantId']!);
//       } else {
//         this.plantId = null;
//       }
//       this.plantName = params['plantName'];
//       if (this.plantName) {
//         this.plantName = atob(params['plantName']!);
//       } else {
//         this.plantName = undefined;
//       }
//     } 
//     });
//   }
//  */
//   constructor(
//     private plot: PlotlyService,
//     private trainService: TrainService,
//     private plantService: PlantsService,
//     private route: ActivatedRoute,
//     private router: Router,
//     private opdataService: OpdataService,
//     private EventlogsService: EventlogsService
//   ) {
 
//     const navigation = this.router.getCurrentNavigation();
//     const state = navigation?.extras?.state || history.state;
   
//     if (state && state.trainId) {
//       // Data from route state
//       this.showselector = state.showselector ?? false;
//       this.trainId = state.trainId;
//       this.plantId = state.plantId || null;
//       this.plantName = state.plantName || undefined;
     
//       console.log("Constructor - State received:", {
//         showselector: this.showselector,
//         trainId: this.trainId,
//         plantId: this.plantId,
//         plantName: this.plantName
//       });
//     } else {
 
//       this.route.queryParams.subscribe(params => {
//         if (params['trainId'] != null) {
//           this.showselector = params["showselector"] === 'true' || params["showselector"] === true;
//           this.trainId = atob(params['trainId']!);
         
//           this.plantId = params['plantId'];
//           if (this.plantId) {
//             this.plantId = atob(params['plantId']!);
//           } else {
//             this.plantId = null;
//           }
         
//           this.plantName = params['plantName'];
//           if (this.plantName) {
//             this.plantName = atob(params['plantName']!);
//           } else {
//             this.plantName = undefined;
//           }
         
//           console.log("Constructor - Query params (fallback)");
//         } else {
//           console.error("No state or query params found!");
//         }
//       });
//     }
//   }
 


//   ngOnInit(): void {
//     if (this.plantId === undefined || this.plantId === null || this.plantId==='') {
    
//       this.plantloader()
//     } else {
//       this.getTrainById();
//     }

//   }

//   plantloader() {
//     let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
//     if (loggedInuserRole.role == 'Standard User') {
//       this.loggedInUserRole = loggedInuserRole.role;
//       this.loggedinUserId = loggedInuserRole.userId;
//       this.plantService.getPlantsByUserId(loggedInuserRole.userId)
//         .subscribe({
//           next: (plants) => {
//             this.plants = plants;
//           },
//         })

//     }
//     else {
//       this.plantService.getAllPlant().subscribe({
//         next: (plants) => {
//           this.plants = plants;
//         },
//         error: (response) => {
//           console.log(response);
//         },
//       });
//     }
//   }

//   getSelectedId(e) {
//     this.plantId = e.target.value;
//     this.plantService.getPlant(this.plantId).subscribe({
//       next: (response) => {
//         this.plantDetails = response;
//         console.log(this.plantDetails);
//       },
//     });
//     this.plantName = this.plantDetails.Name;
//     if (this.loggedInUserRole == 'Standard User') {
//       this.plantAndUserId = this.plantId + 'Z' + this.loggedinUserId;
//       this.trainService.GetAccessibleTrainListByPlantId(this.plantAndUserId)

//         .subscribe(
//           (response: Train[]) => {
//             this.trains = response;
//           },
//           (error: any) => {
//             console.log('error list');
//           }
//         );
//     }
//     else {

//       this.trainService.getTrainByPlantId(this.plantId).subscribe(
//         (response: Train[]) => {
//           this.trains = response;
//         },
//         (error: any) => {
//           console.log('error list');
//         }
//       );
//     }
//   }
//   getSelectedTrainId(e) {
//     this.trainId = e.target.value;
//     this.getTrainById();
//   }

//   onOptionSelected(e) {
//     this.stageselected = e.target.value;
//     let stagestr = this.trainDetails.Stages;
    

//     if (stagestr == 1 || this.stageselected == '1') {
//       return [
//         { Id: 1, Name: 'Total' },
//       ];
//     } else if (stagestr == 2) {
//       if (this.stageselected == '1' || this.stageselected == '2' || this.stageselected == '3') {
//         return [
//           { Id: 1, Name: 'Total' },
//         ];
//       }
//     } else if (stagestr == 3) {
//       if (this.stageselected == '1' || this.stageselected == '2' || this.stageselected == '3' || this.stageselected == '4') {
//         return [
//           { Id: 1, Name: 'Total' },
//           { Id: 2, Name: '1' },
//           { Id: 3, Name: '2' },
//         ];
//       }
//     } else if (stagestr == 4) {
//       if (this.stageselected == '1' || this.stageselected == '2' || this.stageselected == '3' || this.stageselected == '4') {
//         return [
//           { Id: 1, Name: 'Total' },
//           { Id: 2, Name: '1' },
//           { Id: 3, Name: '2' },
//           { Id: 4, Name: '3' },
//         ];
//       }
//     }

//     return [];
//   }
//   getTrainById() {
//     console.log(this.trainId)
//     this.trainService.getTrainById(this.trainId).subscribe({
//       next: (response) => {
//         this.trainDetails = response;
       
//       },
//     });
//   }

//   showGraph() {

//     this.getCalcData(this.stagestr);
//   }
//   getCalcData(stageStr) {


//     this.stagenumber = this.stageselected;
//     this.EventlogsService.getEventLogsListByTrainId(this.trainId).subscribe({
//       next: (response) => {
//         this.Eventlogs = response;
//         console.log(this.Eventlogs);
//       }
//     })

   
//     this.opdataService.GetOPCalcdataNew(this.trainId).subscribe({
//       next: (response) => {
//         this.opCalData = response;
//         let x: Date[] = [];
//         let y: number[] = [];
//         let ysalt: number[
          
//         ] = [];
//         let ypressure: number[] = [];
//         let y1Event: string[] = [];
//         let eventdate: string[] = [];
//         let maxNPF: number[]=[];
         
//         this.maxtotalNPF = this.opCalData.reduce((acc, item) => Math.max(acc, item.TotalNpf),Number.NEGATIVE_INFINITY);
//         this.maxstage1NPF = this.opCalData.reduce((acc, item) => Math.max(acc, item.S1Npf),Number.NEGATIVE_INFINITY);
//         this.maxstage2NPF = this.opCalData.reduce((acc, item) => Math.max(acc, item.S2Npf),Number.NEGATIVE_INFINITY);
//         this.maxstage3NPF = this.opCalData.reduce((acc, item) => Math.max(acc, item.S3Npf),Number.NEGATIVE_INFINITY);

//         this.maxtotalNsp = this.opCalData.reduce((acc, item) => Math.max(acc, item.TotalNsp),Number.NEGATIVE_INFINITY);
//         this.maxstage1Nsp = this.opCalData.reduce((acc, item) => Math.max(acc, item.S1Nsp),Number.NEGATIVE_INFINITY);
//         this.maxstage2Nsp = this.opCalData.reduce((acc, item) => Math.max(acc, item.S2Nsp),Number.NEGATIVE_INFINITY);
//         this.maxstage3Nsp = this.opCalData.reduce((acc, item) => Math.max(acc, item.S3Nsp),Number.NEGATIVE_INFINITY);

//         this.maxtotalNdf = this.opCalData.reduce((acc, item) => Math.max(acc, item.TotalNormDiffPress),Number.NEGATIVE_INFINITY);
//         this.maxstage1Ndf = this.opCalData.reduce((acc, item) => Math.max(acc, item.S1NetDrivePressure),Number.NEGATIVE_INFINITY);
//         this.maxstage2Ndf = this.opCalData.reduce((acc, item) => Math.max(acc, item.S2NetDrivPress),Number.NEGATIVE_INFINITY);
//         this.maxstage3Ndf = this.opCalData.reduce((acc, item) => Math.max(acc, item.S3NetDrivPress),Number.NEGATIVE_INFINITY);

//         this.opCalData.forEach(element => {

//           x.push(new Date(element.Datetime));
//           //stage total
//           if (this.stagenumber == "1") {
//             y.push(element.TotalNpf);
//             ysalt.push(element.TotalNsp * 100);
//             ypressure.push(element.TotalNormDiffPress)
//             this.maxYaxisNpf = this.maxtotalNPF;
//             this.maxYaxisNsp = this.maxtotalNsp;
//             this.maxYaxisNdf = this.maxtotalNdf;
//           }
//           //stage 1
//           else if (this.stagenumber == "2") {
//             y.push(element.S1Npf);
//             ysalt.push(element.S1Nsp * 100);
//             ypressure.push(element.S1NormDiffPress);
//             // this.maxYaxisNpf=this.maxstage1NPF;
//             // this.maxYaxisNsp = this.maxstage1Nsp;
//             // this.maxYaxisNdf = this.maxstage2Ndf;
//             // this.maxYaxisNpf = this.maxstage2Ndf;
//              this.maxYaxisNpf = this.maxstage1NPF;
//             this.maxYaxisNsp = this.maxstage1Nsp; 
//             this.maxYaxisNdf = this.maxstage1Ndf; 
//           }
//           //stage 2
//           else if (this.stagenumber == "3") {
//             y.push(element.S2Npf);
//             ysalt.push(element.S2Nsp * 100);
//             ypressure.push(element.S2NormDiffPress);
//             this.maxYaxisNpf=this.maxstage2NPF;
//             this.maxYaxisNsp=this.maxstage2Nsp;
//             this.maxYaxisNdf=this.maxstage2Ndf;
//           }
//           else if (this.stagenumber == "4") {
//             y.push(element.S3Npf);
//             ysalt.push(element.S3Nsp * 100);
//             ypressure.push(element.S3NormDiffPress)
//             this.maxYaxisNpf=this.maxstage3NPF;
//             this.maxYaxisNsp = this.maxstage3Nsp;
//             this.maxYaxisNdf = this.maxstage3Ndf;
//           }
//         });
//         this.Eventlogs.forEach(element => {
//           y1Event.push(element.Datetime.replace('T'," ") +' '+ element.EventType +' '+element.Observations);
//           eventdate.push(element.Datetime.replace('T'," "));
//         })
//         if (this.trainDetails.Units == 0) 
//           {

//           this.graphName =  ((this.plantDetails?.Name) || this.plantName) + "/" + this.trainDetails.Name + "/Normalized Permeate Flow(m3/hr)<br/>" + this.trainDetails.Systemconfig
//           this.yaxisname1 = "Normalized Permeate Flow(m3/hr)";

//           if (y1Event.length > 0) {

//             this.plot.plotLinePrimaryWithEvents("", "plot", x, y, y1Event, eventdate,this.maxYaxisNpf,this.yaxisname1);
//           }
//           else {
//             this.plot.plotLinePrimary("", "plot", x, y, this.yaxisname1);
//           }

//           this.graphName2 =  ((this.plantDetails?.Name) || this.plantName) + "/" + this.trainDetails.Name + "/Normalized Salt Passage(%)<br/>" + this.trainDetails.Systemconfig
//           this.yaxisname2 = "Normalized Salt Passage(%)";
//           if (y1Event.length > 0) {

//             this.plot.plotLine2WithEvents("", "plot2", x, ysalt, y1Event, eventdate,this.maxYaxisNsp, this.yaxisname2);
//           }
//           else {
//             this.plot.plotLine2("", "plot2", x, ysalt, this.yaxisname2);
//           }

//           this.graphName3 =  ((this.plantDetails?.Name) || this.plantName) + "/" + this.trainDetails.Name + "/Normalized Differential Pressure(bar)<br/>" + this.trainDetails.Systemconfig
//           this.yaxisname3 = "Normalized Differential Pressure(bar)";
//           if(y1Event.length>0)
//             {
//               this.plot.plotLine3WithEvents("", "plot3", x, ypressure, y1Event, eventdate,this.maxYaxisNdf,this.yaxisname3);
//             }
//             else
//             {
//               this.plot.plotLine3("", "plot3", x, ypressure, this.yaxisname3);
//             }
//         }
//         else if (this.trainDetails.Units == 1) {
//           this.graphName =  ((this.plantDetails?.Name) || this.plantName) + "/" + this.trainDetails.Name + "/Normalized Permeate Flow(gpm)<br/>" + this.trainDetails.Systemconfig
//           this.yaxisname1 = "Normalized Permeate Flow(gpm)";
//           if (y1Event.length > 0) 
//             {
           
//             this.plot.plotLinePrimaryWithEvents("", "plot", x, y, y1Event, eventdate,this.maxYaxisNpf,this.yaxisname1);
//           }
//           else {
//             this.plot.plotLinePrimary("", "plot", x, y, this.yaxisname1);
//           }

//           this.graphName2 =  ((this.plantDetails?.Name) || this.plantName) + "/" + this.trainDetails.Name + "/Normalized Salt Passage(%)<br/>" + this.trainDetails.Systemconfig
//           this.yaxisname2 = "Normalized Salt Passage(%)";
//           if (y1Event.length > 0) 
//           {

//             this.plot.plotLine2WithEvents("", "plot2", x, ysalt, y1Event, eventdate,this.maxYaxisNsp, this.yaxisname2);
//           }
//           else 
//           {
//           this.plot.plotLine2("", "plot2", x, ysalt, this.yaxisname2);
//           }

//           this.graphName3 =  ((this.plantDetails?.Name) || this.plantName) + "/" + this.trainDetails.Name + "/Normalized Differential Pressure(psi)<br/>" + this.trainDetails.Systemconfig
//           this.yaxisname3 = "Normalized Differential Pressure(psi)";
//           if(y1Event.length>0)
//             {
//               this.plot.plotLine3WithEvents("", "plot3", x, ypressure, y1Event, eventdate,this.maxYaxisNdf, this.yaxisname3);
//             }
//             else
//             {
//               this.plot.plotLine3("", "plot3", x, ypressure, this.yaxisname3);
//             }
//         }
//       }
//     });

//   }

// }


import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Opdata } from 'src/app/models/opdata.model';
import { OpdataCalc } from 'src/app/models/opdataCalc.model';
import { Stage } from 'src/app/models/stage.interface';
import { Train } from 'src/app/models/train.model';
import { OpdataService } from 'src/app/services/opdata/opdata.service';
import { TrainService } from 'src/app/services/trains/trains.service';
import { PlotlyService } from '../plotly.service';
import { param } from 'jquery';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { Plant } from 'src/app/models/plant.model';
import { EventLogs } from 'src/app/models/eventLog.model';
import { EventlogsService } from 'src/app/services/eventlogs/eventlogs.service';
import { RawCalcTrainDataViewModel } from 'src/app/models/OpRawCalc.model';

@Component({
  selector: 'app-primarygraph',
  templateUrl: './primarygraph.component.html',
  styleUrls: ['./primarygraph.component.scss'],
})
export class PrimarygraphComponent {
  opCalData: RawCalcTrainDataViewModel[] = [];
  plantName: string = '';
  trainDetails: Train = new Train();
  trainInfo: Train = new Train();
  trainId: string = '';
  plantId: string = '';
  graphName: string = '';
  graphName2: string = '';
  graphName3: string = '';
  yaxisname1: string = '';
  yaxisname2: string = '';
  yaxisname3: string = '';
  showselector: boolean = false;
  stageEnabled: boolean = true;
  stageselected: string = '1';
  stagestr: number;
  stagenumber: string = '';
  maxYaxisNpf: number;
  maxYaxisNsp: number;
  maxYaxisNdf: number;

  maxtotalNPF: number;
  maxstage1NPF: number;
  maxstage2NPF: number;
  maxstage3NPF: number;
  ymax: number;
  maxtotalNsp: number;
  maxstage1Nsp: number;
  maxstage2Nsp: number;
  maxstage3Nsp: number;

  maxtotalNdf: number;
  maxstage1Ndf: number;
  maxstage2Ndf: number;
  maxstage3Ndf: number;
  public stage3: Array<Stage> = [
    { Id: 1, Name: 'Total' },
    { Id: 2, Name: '1' },
    { Id: 3, Name: '2' },
    { Id: 4, Name: '3' },
  ];
  public stage2: Array<Stage> = [
    { Id: 1, Name: 'Total' },
    { Id: 2, Name: '1' },
    { Id: 3, Name: '2' },
  ];

  public stageTotal: Array<Stage> = [{ Id: 1, Name: 'Total' }];

  plants: Plant[] = [];
  trains: Train[] = [];
  plantDetails: Plant = new Plant();
  Eventlogs: EventLogs[] = [];
  loggedInUserRole: string;
  loggedinUserId: string;
  plantAndUserId: string;

  constructor(
    private plot: PlotlyService,
    private trainService: TrainService,
    private plantService: PlantsService,
    private route: ActivatedRoute,
    private router: Router,
    private opdataService: OpdataService,
    private EventlogsService: EventlogsService
  ) {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state || history.state;

    if (state && state.trainId) {
      // Data from route state
      this.showselector = state.showselector ?? false;
      this.trainId = state.trainId;
      this.plantId = state.plantId || null;
      this.plantName = state.plantName || undefined;

      console.log('Constructor - State received:', {
        showselector: this.showselector,
        trainId: this.trainId,
        plantId: this.plantId,
        plantName: this.plantName,
      });
    } else {
      this.route.queryParams.subscribe((params) => {
        if (params['trainId'] != null) {
          this.showselector =
            params['showselector'] === 'true' ||
            params['showselector'] === true;
          this.trainId = atob(params['trainId']!);

          this.plantId = params['plantId'];
          if (this.plantId) {
            this.plantId = atob(params['plantId']!);
          } else {
            this.plantId = null;
          }

          this.plantName = params['plantName'];
          if (this.plantName) {
            this.plantName = atob(params['plantName']!);
          } else {
            this.plantName = undefined;
          }

          console.log('Constructor - Query params (fallback)');
        } else {
          console.error('No state or query params found!');
        }
      });
    }
  }

  ngOnInit(): void {
    if (
      this.plantId === undefined ||
      this.plantId === null ||
      this.plantId === ''
    ) {
      this.plantloader();
    } else {
      this.getTrainById();
    }

    //Subscribe to selectedPlant$ to get the plantId when it changes
    this.plantService.selectedPlant$.subscribe(plantId => {
      if (plantId) {
        this.getSelectedId({
          target: {
            value: plantId
          }
        });
      }
    });
        

    // Subscribe to selectedTrain$ to get the trainId when it changes
    this.plantService.selectedTrain$.subscribe(trainId => {
      if (trainId) {
        this.trainId = trainId.toString();
        console.log("Received Train Id:", this.trainId);
        this.getTrainById();
      }
    });

  }

  plantloader() {
    let loggedInuserRole = JSON.parse(
      atob(sessionStorage.getItem('currentUser')!)
    );
    if (loggedInuserRole.role == 'Standard User') {
      this.loggedInUserRole = loggedInuserRole.role;
      this.loggedinUserId = loggedInuserRole.userId;
      this.plantService.getPlantsByUserId(loggedInuserRole.userId).subscribe({
        next: (plants) => {
          this.plants = plants;
        },
      });
    } else {
      this.plantService.getAllPlant().subscribe({
        next: (plants) => {
          this.plants = plants;
        },
        error: (response) => {
          console.log(response);
        },
      });
    }
  }

  getSelectedId(e) {
    this.plantId = e.target.value;
    this.plantService.getPlant(this.plantId).subscribe({
      next: (response) => {
        this.plantDetails = response;
        console.log(this.plantDetails);
      },
    });
    this.plantName = this.plantDetails.Name;
    if (this.loggedInUserRole == 'Standard User') {
      this.plantAndUserId = this.plantId + 'Z' + this.loggedinUserId;
      this.trainService
        .GetAccessibleTrainListByPlantId(this.plantAndUserId)

        .subscribe(
          (response: Train[]) => {
            this.trains = response;
          },
          (error: any) => {
            console.log('error list');
          }
        );
    } else {
      this.trainService.getTrainByPlantId(this.plantId).subscribe(
        (response: Train[]) => {
          this.trains = response;
        },
        (error: any) => {
          console.log('error list');
        }
      );
    }
  }
  getSelectedTrainId(e) {
    this.trainId = e.target.value;
    this.getTrainById();
  }

  onOptionSelected(e) {
    this.stageselected = e.target.value;
    let stagestr = this.trainDetails.Stages;

    if (stagestr == 1 || this.stageselected == '1') {
      return [{ Id: 1, Name: 'Total' }];
    } else if (stagestr == 2) {
      if (
        this.stageselected == '1' ||
        this.stageselected == '2' ||
        this.stageselected == '3'
      ) {
        return [{ Id: 1, Name: 'Total' }];
      }
    } else if (stagestr == 3) {
      if (
        this.stageselected == '1' ||
        this.stageselected == '2' ||
        this.stageselected == '3' ||
        this.stageselected == '4'
      ) {
        return [
          { Id: 1, Name: 'Total' },
          { Id: 2, Name: '1' },
          { Id: 3, Name: '2' },
        ];
      }
    } else if (stagestr == 4) {
      if (
        this.stageselected == '1' ||
        this.stageselected == '2' ||
        this.stageselected == '3' ||
        this.stageselected == '4'
      ) {
        return [
          { Id: 1, Name: 'Total' },
          { Id: 2, Name: '1' },
          { Id: 3, Name: '2' },
          { Id: 4, Name: '3' },
        ];
      }
    }

    return [];
  }
  getTrainById() {
    console.log(this.trainId);
    this.trainService.getTrainById(this.trainId).subscribe({
      next: (response) => {
        this.trainDetails = response;
      },
    });
  }

  showGraph() {
    this.getCalcData(this.stagestr);
  }
  getCalcData(stageStr) {
    this.stagenumber = this.stageselected;
    this.EventlogsService.getEventLogsListByTrainId(this.trainId).subscribe({
      next: (response) => {
        this.Eventlogs = response;
        console.log(this.Eventlogs);
      },
    });

    this.opdataService.GetOPCalcdataNew(this.trainId).subscribe({
      next: (response) => {
        this.opCalData = response;
        let x: Date[] = [];
        let y: number[] = [];
        let ysalt: number[] = [];
        let ypressure: number[] = [];
        let y1Event: string[] = [];
        let eventdate: string[] = [];
        let maxNPF: number[] = [];

        this.maxtotalNPF = this.opCalData.reduce(
          (acc, item) => Math.max(acc, item.TotalNpf),
          Number.NEGATIVE_INFINITY
        );
        this.maxstage1NPF = this.opCalData.reduce(
          (acc, item) => Math.max(acc, item.S1Npf),
          Number.NEGATIVE_INFINITY
        );
        this.maxstage2NPF = this.opCalData.reduce(
          (acc, item) => Math.max(acc, item.S2Npf),
          Number.NEGATIVE_INFINITY
        );
        this.maxstage3NPF = this.opCalData.reduce(
          (acc, item) => Math.max(acc, item.S3Npf),
          Number.NEGATIVE_INFINITY
        );

        this.maxtotalNsp = this.opCalData.reduce(
          (acc, item) => Math.max(acc, item.TotalNsp),
          Number.NEGATIVE_INFINITY
        );
        this.maxstage1Nsp = this.opCalData.reduce(
          (acc, item) => Math.max(acc, item.S1Nsp),
          Number.NEGATIVE_INFINITY
        );
        this.maxstage2Nsp = this.opCalData.reduce(
          (acc, item) => Math.max(acc, item.S2Nsp),
          Number.NEGATIVE_INFINITY
        );
        this.maxstage3Nsp = this.opCalData.reduce(
          (acc, item) => Math.max(acc, item.S3Nsp),
          Number.NEGATIVE_INFINITY
        );

        this.maxtotalNdf = this.opCalData.reduce(
          (acc, item) => Math.max(acc, item.TotalNormDiffPress),
          Number.NEGATIVE_INFINITY
        );
        this.maxstage1Ndf = this.opCalData.reduce(
          (acc, item) => Math.max(acc, item.S1NetDrivePressure),
          Number.NEGATIVE_INFINITY
        );
        this.maxstage2Ndf = this.opCalData.reduce(
          (acc, item) => Math.max(acc, item.S2NetDrivPress),
          Number.NEGATIVE_INFINITY
        );
        this.maxstage3Ndf = this.opCalData.reduce(
          (acc, item) => Math.max(acc, item.S3NetDrivPress),
          Number.NEGATIVE_INFINITY
        );

        this.opCalData.forEach((element) => {
          x.push(new Date(element.Datetime));
          //stage total
          if (this.stagenumber == '1') {
            y.push(element.TotalNpf);
            ysalt.push(element.TotalNsp * 100);
            ypressure.push(element.TotalNormDiffPress);
            this.maxYaxisNpf = this.maxtotalNPF;
            this.maxYaxisNsp = this.maxtotalNsp;
            this.maxYaxisNdf = this.maxtotalNdf;
          }
          //stage 1
          else if (this.stagenumber == '2') {
            y.push(element.S1Npf);
            ysalt.push(element.S1Nsp * 100);
            ypressure.push(element.S1NormDiffPress);
            // this.maxYaxisNpf=this.maxstage1NPF;
            // this.maxYaxisNsp = this.maxstage1Nsp;
            // this.maxYaxisNdf = this.maxstage2Ndf;
            // this.maxYaxisNpf = this.maxstage2Ndf;
            this.maxYaxisNpf = this.maxstage1NPF;
            this.maxYaxisNsp = this.maxstage1Nsp; 
            this.maxYaxisNdf = this.maxstage1Ndf; 
          }
          //stage 2
          else if (this.stagenumber == '3') {
            y.push(element.S2Npf);
            ysalt.push(element.S2Nsp * 100);
            ypressure.push(element.S2NormDiffPress);
            this.maxYaxisNpf = this.maxstage2NPF;
            this.maxYaxisNsp = this.maxstage2Nsp;
            this.maxYaxisNdf = this.maxstage2Ndf;
          } else if (this.stagenumber == '4') {
            y.push(element.S3Npf);
            ysalt.push(element.S3Nsp * 100);
            ypressure.push(element.S3NormDiffPress);
            this.maxYaxisNpf = this.maxstage3NPF;
            this.maxYaxisNsp = this.maxstage3Nsp;
            this.maxYaxisNdf = this.maxstage3Ndf;
          }
        });
        this.Eventlogs.forEach((element) => {
          y1Event.push(
            element.Datetime.replace('T', ' ') +
              ' ' +
              element.EventType +
              ' ' +
              element.Observations
          );
          eventdate.push(element.Datetime.replace('T', ' '));
        });
        if (this.trainDetails.Units == 0) {
            const stageLabel = this.stagenumber == '1' ? 'Total' : 
                     this.stagenumber == '2' ? 'Stage 1' : 
                     this.stagenumber == '3' ? 'Stage 2' : 'Stage 3';
          this.graphName =
            ((this.plantDetails?.Name) || this.plantName) +
            '/' +
            this.trainDetails.Name +
            '/Normalized Permeate Flow(m3/hr)<br/>' +
            this.trainDetails.Systemconfig;
          this.yaxisname1 = 'Normalized Permeate Flow(m3/hr)';

          if (y1Event.length > 0) {
            this.plot.plotLinePrimaryWithEvents(
              '',
              'plot',
              x,
              y,
              y1Event,
              eventdate,
              this.maxYaxisNpf,
              this.yaxisname1,
               stageLabel
            );
          } else {
            this.plot.plotLinePrimary('', 'plot', x, y, this.yaxisname1,stageLabel);
          }

          this.graphName2 =
            ((this.plantDetails?.Name) || this.plantName) +
            '/' +
            this.trainDetails.Name +
            '/Normalized Salt Passage(%)<br/>' +
            this.trainDetails.Systemconfig;
          this.yaxisname2 = 'Normalized Salt Passage(%)';
          if (y1Event.length > 0) {
            this.plot.plotLine2WithEvents(
              '',
              'plot2',
              x,
              ysalt,
              y1Event,
              eventdate,
              this.maxYaxisNsp,
              this.yaxisname2,
                  stageLabel
            );
          } else {
            this.plot.plotLine2('', 'plot2', x, ysalt, this.yaxisname2,    stageLabel);
          }

          this.graphName3 =
           ((this.plantDetails?.Name) || this.plantName) +
            '/' +
            this.trainDetails.Name +
            '/Normalized Differential Pressure(bar)<br/>' +
            this.trainDetails.Systemconfig;
          this.yaxisname3 = 'Normalized Differential Pressure(bar)';
          if (y1Event.length > 0) {
            this.plot.plotLine3WithEvents(
              '',
              'plot3',
              x,
              ypressure,
              y1Event,
              eventdate,
              this.maxYaxisNdf,
              this.yaxisname3,
                  stageLabel
            );
          } else {
            this.plot.plotLine3('', 'plot3', x, ypressure, this.yaxisname3,    stageLabel);
          }
        } else if (this.trainDetails.Units == 1) {
           const stageLabel = this.stagenumber == '1' ? 'Total' : 
                     this.stagenumber == '2' ? 'Stage 1' : 
                     this.stagenumber == '3' ? 'Stage 2' : 'Stage 3';
          this.graphName =
             ((this.plantDetails?.Name) || this.plantName) +
            '/' +
            this.trainDetails.Name +
            '/Normalized Permeate Flow(gpm)<br/>' +
            this.trainDetails.Systemconfig;
          this.yaxisname1 = 'Normalized Permeate Flow(gpm)';
          if (y1Event.length > 0) {
            this.plot.plotLinePrimaryWithEvents(
              '',
              'plot',
              x,
              y,
              y1Event,
              eventdate,
              this.maxYaxisNpf,
              this.yaxisname1,
              stageLabel
            );
          } else {
            this.plot.plotLinePrimary('', 'plot', x, y, this.yaxisname1,stageLabel);
          }

          this.graphName2 =
            ((this.plantDetails?.Name) || this.plantName) +
            '/' +
            this.trainDetails.Name +
            '/Normalized Salt Passage(%)<br/>' +
            this.trainDetails.Systemconfig;
          this.yaxisname2 = 'Normalized Salt Passage(%)';
          if (y1Event.length > 0) {
            this.plot.plotLine2WithEvents(
              '',
              'plot2',
              x,
              ysalt,
              y1Event,
              eventdate,
              this.maxYaxisNsp,
              this.yaxisname2,
              stageLabel
            );
          } else {
            this.plot.plotLine2('', 'plot2', x, ysalt, this.yaxisname2,stageLabel);
          }

          this.graphName3 =
              ((this.plantDetails?.Name) || this.plantName) +
            '/' +
            this.trainDetails.Name +
            '/Normalized Differential Pressure(psi)<br/>' +
            this.trainDetails.Systemconfig;
          this.yaxisname3 = 'Normalized Differential Pressure(psi)';
          if (y1Event.length > 0) {
            this.plot.plotLine3WithEvents(
              '',
              'plot3',
              x,
              ypressure,
              y1Event,
              eventdate,
              this.maxYaxisNdf,
              this.yaxisname3,
              stageLabel
            );
          } else {
            this.plot.plotLine3('', 'plot3', x, ypressure, this.yaxisname3,stageLabel);
          }
        }
      },
    });
  }
}
